import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";
import renderMarkdown from "../markdown";

const ConfirmationBlock = observer(({ block }) => {
  const resolved = Boolean(block.resolution);
  const destructive = Boolean(block.destructive);

  return (
    <div
      className={`copilotConfirm ${resolved ? "resolved" : ""} ${
        destructive ? "destructive" : ""
      }`}
    >
      <div className="copilotConfirm__prompt">
        <i className="material-icons-outlined">
          {destructive ? "error_outline" : "task_alt"}
        </i>
        {/* The prompt carries **bold** — it read as literal asterisks before. */}
        <div className="copilotConfirm__promptBody">
          {renderMarkdown(block.prompt)}
        </div>
      </div>
      {!resolved ? (
        <div className="copilotConfirm__actions">
          <button
            type="button"
            className={`copilotConfirm__btn primary ${
              destructive ? "danger" : ""
            }`}
            disabled={copilotStore.streaming}
            onClick={() => copilotStore.respondConfirmation(block.id, true)}
          >
            {block.confirmLabel || "Confirm"}
          </button>
          <button
            type="button"
            className="copilotConfirm__btn ghost"
            disabled={copilotStore.streaming}
            onClick={() => copilotStore.respondConfirmation(block.id, false)}
          >
            {block.cancelLabel || "Cancel"}
          </button>
        </div>
      ) : (
        <div className="copilotConfirm__resolution">
          <i className="material-icons-outlined">
            {block.resolution === "confirmed" ? "check_circle" : "cancel"}
          </i>
          <span>
            {block.resolution === "confirmed"
              ? block.confirmLabel || "Confirmed"
              : block.cancelLabel || "Cancelled"}
          </span>
        </div>
      )}
    </div>
  );
});

export default ConfirmationBlock;
